import { Dialog } from '@material-ui/core';
import { useResponsiveValue } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import {
  InstantTransferDialogContent,
  Source,
} from 'shared/modules/superpay/instant-transfer/InstantTransferDialogContent';

interface InstantTransferDialogProps {
  open: boolean;
  onClose: () => void;
  loadGUID?: string;
  source?: Source;
}

export function InstantTransferDialog({
  open,
  onClose,
  loadGUID,
  source,
}: InstantTransferDialogProps) {
  const isMobile = useResponsiveValue(true, true, false);

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} fullWidth={isMobile}>
      <Box width={['100%', '100%', '624px']}>
        <InstantTransferDialogContent
          onClose={onClose}
          loadGUID={loadGUID}
          source={source}
        />
      </Box>
    </Dialog>
  );
}
